import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class StakeholderTooltipService {
    createCaseCopy: Subject<string> = new Subject();

    send(stakeHolderId: string) {
        this.createCaseCopy.next(stakeHolderId);
    }

    public getCase(): Observable<string> {
        return this.createCaseCopy.asObservable();
    }
}
